import { render, staticRenderFns } from "./ChargerConnectors.vue?vue&type=template&id=2608ab54&lang=pug&"
import script from "./ChargerConnectors.vue?vue&type=script&lang=ts&"
export * from "./ChargerConnectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports